import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=756f8ff2&scoped=true&"
import script from "./NumberView.vue?vue&type=script&lang=js&"
export * from "./NumberView.vue?vue&type=script&lang=js&"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=756f8ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f8ff2",
  null
  
)

export default component.exports